module.exports = __webpack_public_path__ + "0b3db4ffa65705848abe5f551d9322a0.msgpack";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/game/models/helper.msgpack
 ** module id = 594
 ** module chunks = 0
 **/